import { NavMaintenanceCard } from "./components/navMaintenanceCard";
import { Link } from "react-router-dom";
import { NavWorkHours } from "./components/navWorkHours";
import { useEffect, useState, useCallback } from "react";
import config from '../../../configuration/config';
import axios from "axios";
import { useTranslation } from "react-i18next";
import { slugCombine } from '../../../utils/slugManager';
import Skeleton from 'react-loading-skeleton'
export function NavMaintenance({ ...prop }) {
    const { t: trans, i18n } = useTranslation(["common", "form", "model", "navbar", "info"]);
    //----------------------------------------------------------
    const [maintenanceOffers, setMaintenanceOffers] = useState(null);
    // to intialize the offers
    const intialOffers = useCallback(() => {
        axios.post(
            `${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchMaintenanceOffers`,
            {}
        ).then(response => {
            const responseData = response.data.map((e, index) => {
                return {
                    id: e[`${trans("navbar:slug")}`],
                    otherSlug: e.slugEn,
                    slug: e.slugAr,
                    image: e.image,
                    description: e[`${trans("model:name")}`],
                    price: e.price,
                    days: e.Days
                }
            });
            setMaintenanceOffers(responseData);
        }
        ).catch(error => {
            console.log(error);
        });

    }, [trans]);
    //-----------------------------------------------------------
    useEffect(() => {
        intialOffers();
    }, [intialOffers]);
    //-------------------------------------------------------------
    return (
        <div className={"nav-mega-menu bg-white box-shadow border-radius  " + prop.className}>
            <div className="my-4 text-20 p-8 border-radius nav-grid-3-cols">
                <div>
                    <h3 className="nav-heading">
                        {
                            trans("navbar:man_offer")
                        }
                    </h3>

                    {
                        maintenanceOffers != null ?

                            <div className="nav-maintenance-container nice-flex nice-flex-center">
                                {


                                    (maintenanceOffers != null && maintenanceOffers.length > 0) ? maintenanceOffers?.map((offer, index) => {
                                        return <NavMaintenanceCard
                                            key={index}
                                            id={slugCombine(offer.slug, offer.otherSlug)}
                                            description={offer.description}
                                            image={config.mainURL + offer.image}
                                            price={offer.price}
                                            days={offer.days}
                                        />
                                    }) : (<div className="nice-flex nice-flex-column nice-flex-center">
                                        <img src='/assets/icons/sad.svg' alt="hassan jameel sad" />
                                        <h1 className="text-14 text-bold my-3">{trans("info:no_offer")}</h1>
                                    </div>)


                                }
                            </div>
                            :
                            <>
                                <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"100%"}
                                    containerClassName={"nav-maintenance-container "} className={""}
                                    inline={true} />

                            </>

                    }

                </div>
                <div className={"nav-grid-middle"}>
                    <h3 className="nav-heading">
                        {
                            trans("navbar:man_services")
                        }
                    </h3>

                    <div className="nav-periodic-btn-container flex items-center justify-center h-full pb-20">
                        <Link to="/periodic-maintenance" className="nav-periodic-perfect-btn">
                            <div className="btn-inner">
                                <img src="/assets/icons/services/maintenance-periodic.svg" alt="" className="btn-icon" />
                                <span>{trans("navbar:periodic_maintenance")}</span>
                            </div>
                        </Link>
                    </div>

                </div>
                <div>
                    <h3 className="nav-heading">
                        {
                            trans("navbar:work_hours")
                        }
                    </h3>
                    <NavWorkHours department={12} />
                </div>
            </div>
        </div>
    );
}